import React from "react"

interface AlertIconProps {
    size: number,
    className?: string;
}
export const AlertIcon = ({ size = 43, className = "" }: AlertIconProps) => {

    return (

        <svg width={size} height={size} viewBox="0 0 512 512">
            <title>alerta</title>
            <path d="M256,80c-8.66,0-16.58,7.36-16,16l8,216a8,8,0,0,0,8,8h0a8,8,0,0,0,8-8l8-216C272.58,87.36,264.66,80,256,80Z"
                className={className}
                style={{
                    fill: "none",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "32px"
                }} />
            <circle cx="256" cy="416" r="16"
                className={className}
                style={{
                    fill: "none",
                    strokeLinecap: "round",
                    strokeLinejoin: "round", strokeWidth: "32px"
                }} />
        </svg>
    )

} 